import { withLayout } from '../../layout';

import TeamsPage from './teams.page';

export default withLayout(TeamsPage);
